import { createService, mapServiceCall } from "@/Services/BaseService";
import { mapProcessesToDisplay } from "../../Tools/ProcessMapper";

const ProcessService = createService("api/Process");

export function getProcesses() {
  return ProcessService.get("/AllProcessesUipath");
}

export function getProcessesMapped() {
  return mapServiceCall(getProcesses(), mapProcessesToDisplay);
}